export const placeholderTexts = {
  textNotFound: "Could not display",
  versionText: "1.0.0",
  sideBarProfileName: "-",
  sideBarEmailId: "-",
  mobileNo: "-",
  profileName: "--",
  serviceName: "--",
};
